import type { FC } from "react";
import ErrorIcon from "@mui/icons-material/Error";
import CheckIcon from "@mui/icons-material/CheckCircle";
import { Box } from "@mui/material";
import { P } from "theme/typography";

interface Props {
  successCount: number;
  errorCount: number;
  filesCount: number;
}
const FileUploadPrintout: FC<Props> = ({ successCount, errorCount, filesCount }) => {
  const allSuccess = successCount === filesCount;
  const iconSize = 20;
  return (
    <Box
      sx={{
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
      }}>
      {allSuccess ? (
        <CheckIcon sx={{ mr: 0.5, width: iconSize, height: iconSize, color: "success.main" }} />
      ) : errorCount > 0 ? (
        <ErrorIcon sx={{ width: iconSize, height: iconSize, color: "error.main", mr: 0.5 }} />
      ) : (
        <></>
      )}
      <P variant="subtitle2">
        <strong>
          {successCount} / {filesCount}
        </strong>{" "}
        Uploads succeeded (<strong>{errorCount}</strong> failed)
      </P>
      {!allSuccess && <P variant="subtitle2"></P>}
    </Box>
  );
};

export default FileUploadPrintout;
